import { useContext } from 'react'
import { Header } from '@splunk-iteng/header-footer'
import { BASE_URL } from 'config/constants'
import { API_ROUTES } from 'config/routes'
import { AuthContext } from '../Authentication'

function Navbar() {
  const { authState, authActions } = useContext(AuthContext)
  const currentUser = authState?.currentUser

  return (
    <Header
      login={{
        label: 'Already have an account?',
        url: `${BASE_URL}${API_ROUTES.login}`,
        urlLabel: 'Log in',
      }}
      testId="navbar-testid"
      user={
        currentUser
          ? {
              accountLabel: 'Account',
              accountUrl: `${BASE_URL}${API_ROUTES.login}`,
              logoutLabel: 'Log out',
              name: currentUser.name,
              onLogout: () => {
                authActions.clearCurrentUser()
                window.location.assign(`${BASE_URL}${API_ROUTES.login}`)
              },
            }
          : undefined
      }
      variant="light"
    />
  )
}

export default Navbar
